import React, { useContext } from "react";
import "../css/sign.css";
import AuthContext from "../context/AuthContext";
import { Link } from "react-router-dom";

const Register = () => {
  let { registerUser } = useContext(AuthContext);
  const FormHeader = (props) => <h2 id="headerTitle">{props.title}</h2>;
  const OtherMethods = (props) => (
    <div id="alternativeLogin">
      <Link className="nav-link" to="/signin">Or Login</Link>
      <div id="iconGroup">
        <Google />
      </div>
    </div>
  );
  const Google = (props) => <link to="#" id="googleIcon"></link>;

  const FormInput = (props) => (
    <div className="rows">
      <label>{props.description}</label>
      <input
        type={props.type}
        name={props.name}
        placeholder={props.placeholder}
      />
    </div>
  );

  const FormButton = (props) => (
    <div id="button" className="rows">
      <button type="submit">{props.title}</button>
    </div>
  );

  const RegisterForm = (props) => (
    <>
      <FormInput
        description="Name"
        placeholder="Enter your Firstname Lastname"
        type="text"
        name="firstname"
      />
      <FormInput
        description="Username/Email"
        placeholder="Enter your username"
        type="text"
        name="username"
      />
      <FormInput
        description="Password"
        placeholder="Enter your password"
        type="password"
        name="password"
      />
      <FormInput
        description="Re-password"
        placeholder="Enter your Re-password"
        type="password"
        name="repassword"
      />
      <FormButton title="Register" />
    </>
  );

  return (
    <div className="container">
      <div id="loginform">
        <form onSubmit={registerUser}>
          <FormHeader title="Register" />
          <RegisterForm />
          <OtherMethods />
        </form>
      </div>
    </div>
  );
};

export default Register;
